import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-solutions-page',
  templateUrl: './solutions-page.component.html',
  styleUrls: ['./solutions-page.component.scss']
})
export class SolutionsPageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
